import React from "react";

import { AdminAccountsProvider } from "./AdminAccountsProvider";
import { AdminAppConnectMastersProvider } from "./AdminAppConnectMastersProvider";
import { AdminAppEndpointAddonMastersProvider } from "./AdminAppEndpointAddonMastersProvider";
import { AdminAppPermissionMastersProvider } from "./AdminAppPermissionMastersProvider";
import { AdminAppViewMasterProvider } from "./AdminAppViewMasterProvider";
import { AdminAppViewMastersProvider } from "./AdminAppViewMastersProvider";
import { AdminCIFARelationsProvider } from "./AdminCIFARelationsProvider";
import { AdminCIMastersProvider } from "./AdminCIMastersProvider";
import { AdminOrganizationMembersProvider } from "./AdminOrganizationMembersProvider";
import { AdminOrganizationProvider } from "./AdminOrganizationProvider";
import { AdminOrganizationRolesProvider } from "./AdminOrganizationRolesProvider";
import { AdminOrganizationVersionCategoriesProvider } from "./AdminOrganizationVersionCategoriesProvider";
import { AdminOrganizationViewMastersProvider } from "./AdminOrganizationViewMastersProvider";
import { AdminOrganizationsProvider } from "./AdminOrganizationsProvider";

/**
 * @description 管理者ビュー向けのプロバイダ
 */
export const AdminProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <AdminOrganizationsProvider>
      <AdminAccountsProvider>
        <AdminAppViewMastersProvider>
          <AdminAppConnectMastersProvider>
            <AdminAppEndpointAddonMastersProvider>
              <AdminAppPermissionMastersProvider>
                <AdminCIMastersProvider>
                  <AdminCIFARelationsProvider>
                    <AdminOrganizationProvider>
                      <AdminOrganizationViewMastersProvider>
                        <AdminAppViewMasterProvider>
                          <AdminOrganizationMembersProvider>
                            <AdminOrganizationVersionCategoriesProvider>
                              <AdminOrganizationRolesProvider>
                                {children}
                              </AdminOrganizationRolesProvider>
                            </AdminOrganizationVersionCategoriesProvider>
                          </AdminOrganizationMembersProvider>
                        </AdminAppViewMasterProvider>
                      </AdminOrganizationViewMastersProvider>
                    </AdminOrganizationProvider>
                  </AdminCIFARelationsProvider>
                </AdminCIMastersProvider>
              </AdminAppPermissionMastersProvider>
            </AdminAppEndpointAddonMastersProvider>
          </AdminAppConnectMastersProvider>
        </AdminAppViewMastersProvider>
      </AdminAccountsProvider>
    </AdminOrganizationsProvider>
  );
};

/**
 * @description aa:developer 向けの管理者ビュープロバイダ（アカウント管理のみ）
 */
export const AdminDeveloperProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return <AdminAccountsProvider>{children}</AdminAccountsProvider>;
};
